import type { ComponentPropsWithRef, ReactNode } from 'react'

import { useFocusRing } from '@react-aria/focus'

import { type ButtonPlain, useLoading } from '@subaio/components'

import { FocusVisibleInset } from 'components/FocusVisible'

import { Row } from './Row'
import { RowButton } from './RowButton'

type Props = {
	children: ReactNode
	className?: string
} & ComponentPropsWithRef<typeof ButtonPlain>

export const Item = ({ onClick, className, children }: Props) => {
	const isLoading = useLoading()
	const { isFocusVisible, focusProps } = useFocusRing()

	if (onClick && !isLoading) {
		return (
			<RowButton {...focusProps} className={className} onClick={onClick}>
				<FocusVisibleInset isFocusVisible={isFocusVisible} />
				{children}
			</RowButton>
		)
	}
	return <Row className={className}>{children}</Row>
}
